/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Team_Share_Save_ErrorInputs */



/**
* | output |
* | --- |
* | "Error saving share. {message}" |
*
* @param {Team_Share_Save_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_save_error = /** @type {((inputs: Team_Share_Save_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Save_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Erreur lors de l’enregistrement du partage. ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Speichern der Freigabe. ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Errore durante il salvataggio della condivisione. ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ошибка сохранения общего ресурса. ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al guardar el recurso compartido. ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`保存分享时出错。${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`共有の保存中にエラーが発生しました。${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`शेयर सहेजने में त्रुटि। ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Erro ao salvar o compartilhamento. ${i?.message}`)
	return /** @type {LocalizedString} */ (`Error saving share. ${i?.message}`)
});